<template>
    <v-container
        class="align-start"
        fill-height
    >
        <v-col class="align-self-stretch">
            <v-btn
                large
                color="primary"
                icon
                depressed
                :href="'/user/settings'"
            >
                <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
            Back to settings
            <iframe
                v-if="verificationUrl"
                id="shuftipro-iframe"
                :src="verificationUrl"
                name="shuftipro-iframe"
                allow="camera"
                dataset-removable="true"
            />
        </v-col>
    </v-container>
</template>

<script>
    export default {
        name: 'UserIdentityVerification',
        data() {
            return {
                verificationUrl: undefined,
            };
        },
        mounted() {
            Vue.backendApi()
                .user(this.$store.state.user.id)
                .getIdentityVerificationUrl()
                .then((response) => {
                    this.verificationUrl = response.data.verification_url;
                })
                .catch((error) => {
                    this.$swal({
                        type: 'error',
                        title: 'There was an error with our identity verification service',
                        text: error.message
                    });
                });
        },
    };
</script>

<style scoped>
iframe {
    width: 100%;
    height: 100%;
    min-width: 500px;
    min-height: 500px;
    overflow: scroll;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: 0;
    padding: 0;
    border: 0;
    z-index: 1;
}

body {
    background-color: transparent;
}
.heading, .description {
    color: #000;
}

.new-agree-btn {
    height: 44px !important;
    border-radius: 4px!important;
    background-color: #3F51B5!important;
    border: 1px solid #3F51B5!important;
    font-family: Roboto, sans-serif !important;
    font-weight: 200 !important;
    text-transform: uppercase !important;
    letter-spacing: .1em !important;
}

.new-disagree-btn {
    height: 44px !important;
    border-radius: 4px!important;
    background-color: transparent!important;
    border: 1px solid #D32F2F!important;
    font-family: Roboto, sans-serif !important;
    font-weight: 200 !important;
    text-transform: uppercase !important;
    letter-spacing: .1em !important;
    color: #D32F2F!important;
}

.new-agree-btn:hover {
    color: #3F51B5!important;
    border: 1px solid #3F51B5 !important;
    background-color: #3F51B533 !important;
    -webkit-box-shadow: unset !important;
    box-shadow: unset !important;
}

.new-disagree-btn:hover {
    color: #D32F2F!important;
    border: 1px solid #D32F2F !important;
    background-color: #D32F2F33 !important;
    -webkit-box-shadow: unset !important;
    box-shadow: unset !important;
}
</style>
